export const getGMTTimestamp = (dateString) => {
  // Split the date string into components
  const [day, month, year] = dateString.split('-').map(Number);

  // Get the equivalent timestamp in UTC
  const gmtTimestamp = Date.UTC(year, month - 1, day, 0, 0, 0);

  return gmtTimestamp;
};
